"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function compareByFieldValue(field, value) {
    return function (m1, m2) {
        if (m1[field] === value && m2[field] !== value) {
            return -1;
        }
        if ((m1[field] === value && m2[field] === value) ||
            (m1[field] !== value && m2[field] !== value)) {
            return 0;
        }
        return 1;
    };
}
exports.compareByFieldValue = compareByFieldValue;
function uniqueStrings(strings) {
    var noDupStr = new Set(strings);
    return tslib_1.__spread(noDupStr);
}
exports.uniqueStrings = uniqueStrings;
//# sourceMappingURL=utils.js.map